import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import CustomFields from 'modules/custom_resources/components/CustomFields'
import { CustomFieldsByGroupCollection } from 'modules/custom_resources/store/collections/customFields/byGroup'
import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import ResourceFieldsCollection from 'modules/custom_resources/store/collections/customFields/resourceFields'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type { IResourceField } from 'modules/custom_resources/store/models/customFields/ResourceField'

const Projects = () => {
  const { company } = useCurrentSession()
  const customFieldsByGroup = new CustomFieldsByGroupCollection()
  const usageGroup = CustomField.UsageGroups.timeTrackingProjects
  const { loading } = useAsyncData(() => customFieldsByGroup.byUsageGroup([usageGroup]), [])

  const resourceFieldCollection = new ResourceFieldsCollection([], {
    model_ref: 'company',
    instance_id: company.id,
  })

  const createCustomField = (data: Record<string, string | number>) =>
    customFieldsByGroup.createForGroup(usageGroup, data)

  const existingCustomFieldsByGroup = !!customFieldsByGroup.models.length

  const getModalTitle = () =>
    existingCustomFieldsByGroup
      ? i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.create.title')
      : i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.edit.title')

  const getModalDescription = () =>
    existingCustomFieldsByGroup
      ? i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.create.description')
      : i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.edit.description')

  //TODO: This module will be deleted so we disable it for uninitialzed companies
  if (!existingCustomFieldsByGroup) {
    return null
  }

  return (
    <CustomFields
      canCreateCustomField={!loading && !existingCustomFieldsByGroup}
      createCustomField={createCustomField}
      createResourceField={(data: Partial<IResourceField>) => resourceFieldCollection.create(data)}
      customFields={customFieldsByGroup.models}
      allowedFieldTypes={[FieldTypes.singleChoice]}
      modalIllustration="input-field"
      title={i18n.t('app_store_v2.apps.time_tracking.settings.projects.title')}
      description={i18n.t('app_store_v2.apps.time_tracking.settings.projects.description')}
      emptyMessage={i18n.t('app_store_v2.apps.time_tracking.settings.projects.empty_message')}
      modalTitle={getModalTitle()}
      modalDescription={getModalDescription()}
      modalLabel={i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.label')}
      modalPlaceholder={i18n.t(
        'app_store_v2.apps.time_tracking.settings.projects.modal.placeholder'
      )}
      modalButton={i18n.t('app_store_v2.apps.time_tracking.settings.projects.modal.edit.title')}
      addQuestionLabel={i18n.t('app_store_v2.apps.time_tracking.settings.projects.add')}
      isLoading={loading}
      showAllowedFieldTypes={false}
      showRequired={false}
      hideCustomResourceAssignment
      canEditCustomField
    />
  )
}

export default observer(Projects)
